import { PlanktonProductConfig } from './PlanktonProductConfig';

const devCalkinsProductConfig: PlanktonProductConfig = {
  planktonVersionPrefix: 'onecms/:PRODUCT_ID',
  edsLtiRceToolId: '2ad55c2f-39e7-46fa-8c1f-f5035e473f73',
  edsLtiVideoToolId: '26853de3-1a7a-44f1-849a-f02c438637d7',
};

export default devCalkinsProductConfig;
